import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import warn from '../../utils/warn.js';
import { usePaginationPerPageSelect } from './hooks/usePaginationPerPageSelect.js';
import { PER_PAGE_SELECT_BEFORE_LABEL_DEFAULT, setPerPageSelectAfterLabelDefault, setSelectAriaLabelDefault } from './defaultStrings.js';
import { jsx } from '@emotion/react';
import { Text } from '../Text/Text.js';
import { Select } from '../Select/Select.js';
import './hooks/usePaginationContext.js';
import './PaginationContext.js';
import '../../utils/createResponsive.js';
import '../../_rollupPluginBabelHelpers-c245b26a.js';
import '@indeed/ifl-icons/ChevronDown';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/mergeRefs.js';
import '../../hooks/useHasFocus.js';
import '../IconWrapper/IconWrapper.js';

const PerPageContainer = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: ["orientation"],
  shouldForwardProp: prop => prop !== "orientation",
  target: "e1gdqogr0"
} : {
  styleProps: ["orientation"],
  shouldForwardProp: prop => prop !== "orientation",
  target: "e1gdqogr0",
  label: "PerPageContainer"
})(_ref => {
  let {
    orientation
  } = _ref;
  return {
    alignItems: "center",
    border: "1px solid",
    borderColor: "border.weak",
    borderRadius: "md",
    boxSizing: "border-box",
    bg: "background",
    display: "flex",
    flexGrow: orientation === "vertical" ? 1 : 0,
    justifyContent: "center",
    listStyle: "none",
    marginInlineEnd: 0,
    marginInlineStart: 0,
    marginBlockEnd: 0,
    marginBlockStart: 0,
    paddingInlineEnd: 4,
    paddingInlineStart: 4,
    paddingBlockEnd: 2,
    paddingBlockStart: 2
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const PaginationPerPageSelect = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    itemsPerPageOptions,
    onItemsPerPageChange,
    beforeLabel = PER_PAGE_SELECT_BEFORE_LABEL_DEFAULT,
    setAfterLabel = setPerPageSelectAfterLabelDefault,
    setSelectAriaLabel = setSelectAriaLabelDefault
  } = _ref2;
  const {
    paginationContext,
    handleSelectChange
  } = usePaginationPerPageSelect({
    onItemsPerPageChange
  });
  if (!paginationContext) {
    warn("<PaginationPerPageSelect> should only be used within a parent <Pagination> component.");
    return null;
  }
  const {
    totalItems,
    itemsPerPage,
    orientation
  } = paginationContext;
  return jsx(PerPageContainer, {
    ref: ref,
    orientation: orientation
  }, jsx(Text, null, beforeLabel), jsx(Select, {
    sx: {
      inlineSize: "10ch",
      marginInlineStart: 2,
      marginInlineEnd: 2,
      "& > select": {
        paddingInlineEnd: 6
      }
    },
    "aria-label": setSelectAriaLabel({
      itemsPerPage,
      totalItems
    }),
    size: "sm",
    onChange: handleSelectChange,
    value: itemsPerPage
  }, itemsPerPageOptions.map(option => jsx("option", {
    key: option,
    value: option
  }, option))), jsx(Text, {
    sx: {
      whiteSpace: "nowrap"
    }
  }, setAfterLabel(totalItems)));
});

export { PaginationPerPageSelect };
